import {json} from '../core/data-source/json.mapper';

export enum RoutingModeKeys {
    CAR_FAST = 'CAR_FAST',
    TRUCK_SLOW = 'TRUCK_SLOW',
    TRANSIT = 'TRANSIT',
    PEDESTRIAN = 'PEDESTRIAN'
}

export class RoutingModeRecord {
    @json({jsonName: 'id'})
    key: string;

    @json() name: string;

    @json() useTruckAttributes: boolean;
}
